import React from "react";
import fp from "lodash/fp";
import Moment from "react-moment";

import styles from "./appTimestamps.module.scss";

const AppTimestamps = ({ application }) => {
	return (
		<div className={styles.timestampContainer}>
			<div className={styles.createdUpdatedLeft}>
				<div className="mb-2" data-autotest="createAt">
					Created at:
					{application && application.createdOf && (
						<Moment
							format="DD MMMM YYYY h:mm a"
							utc
							local
							className={styles.time}
						>
							{application.createdOf}
						</Moment>
					)}
				</div>
				<div data-autotest="updatedAt">
					Updated at:
					{application && application.updatedOf && (
						<Moment
							format="DD MMMM YYYY h:mm a"
							utc
							local
							className={styles.time}
						>
							{application.updatedOf}
						</Moment>
					)}
				</div>
			</div>
			<div>
				<div className="mb-2" data-autotest="createBy">
					Created by:
					<span className={styles.time}>
						{fp.get("createdBy", application)}
					</span>
				</div>
				<div data-autotest="updateBy">
					Updated by:
					<span className={styles.time}>
						{fp.get("updatedBy", application)}
					</span>
				</div>
			</div>
		</div>
	);
};

export default AppTimestamps;
